import React, { useContext } from "react";
import { HiOutlineUsers } from "react-icons/hi";
import { FiShoppingBag } from "react-icons/fi";
import { Link } from "react-router-dom";
import { context } from "../../FrontPanel/FrontPanel";
import Login from "../../Login/Login";
const Navbar = () => {
  const { setIsOpen, cart, userData, setIsLoginOpen, address } =
    useContext(context);
  return (
    <div className="">
      <div
        className={` top-section hidden md:block flex md:grid md:grid-cols-11 bg-white shadow-lg grid-flow-row-dense`}
      >
        <div className="lg:border-r-2  sm:col-span-5 md:col-span-8 lg:col-span-2  py-3 px-2 sm:py-4 sm:px-4 md:py-3 md:px-4">
          <Link to="/">
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#134E47]">
              Great Pharma
            </h1>
          </Link>
        </div>
        <div className=" sm:col-span-11 md:col-span-10 lg:col-span-6 sm:grid sm:grid-cols-2">
          <div className="border-r-2  d-flex py-3 px-2 sm:py-3 sm:px-4 md:py-5 md:px-4">
            <label className="text-[#134E47]">Delivering To: </label>
            <select className="focus:outline-none focus:border-0 text-[#134E47] font-semibold">
              <option className=" text-[red]">{address}</option>
            </select>
          </div>
          <div className="  d-flex py-3 px-6 sm:py-4 sm:px-10 md:py-5 md:px-4">
            <label className="text-[#134E47]">When: </label>
            <select className="focus:outline-none focus:border-0 text-[#134E47] font-semibold">
              <option className=" text-[red]">ASAP</option>
            </select>
          </div>
        </div>
        <div className="border-x-2 d-flex py-3 px-4 sm:py-4 sm:px-10 md:py-4 md:px-10">
          <p className="text-[#134E47] font-bold">EN</p>
        </div>
        <div className="border-r-2 d-flex py-3 px-6 sm:py-4 sm:px-10 md:py-4 md:px-4">
          {userData?.user?.name ? (
            <Link to={`/profile/${userData?.user?.id}`}>
              <button className="text-[#134E47] font-semibold">
                <span className="bg-[#134E47] p-1 rounded-full text-center ">
                  <HiOutlineUsers className="inline-block m-1 text-white" />
                </span>
                <span className="hidden lg:inline">Profile</span>
              </button>
            </Link>
          ) : (
            <button
              onClick={() => setIsLoginOpen(true)}
              className="text-[#134E47] font-semibold"
            >
              <span className="bg-[#134E47] p-1 rounded-full text-center ">
                <HiOutlineUsers className="inline-block m-1 text-white" />
              </span>
              <span className="hidden lg:inline">Login</span>
            </button>
          )}
        </div>
        <div className="d-flex py-3 px-6 sm:py-4 sm:px-10 md:py-4 md:px-4">
          <button className="text-[#134E47] font-semibold">
            <span className="bg-[#134E47] p-1 rounded-full text-center ">
              <FiShoppingBag className="text-white inline-block m-1" />
            </span>
            <span className="hidden lg:inline">Cart</span>
          </button>
        </div>
      </div>
      <div className={`top-section-small block md:hidden bg-white shadow-lg `}>
        <div className=" flex justify-between py-3 px-2 ">
          <div className=" d-flex py-3 px-6 sm:py-4 sm:px-10 md:py-4 md:px-4">
            <button className="text-[#134E47] font-semibold">
              <span className="bg-[#134E47] p-1 rounded-full text-center ">
                <HiOutlineUsers className="inline-block m-1 text-white" />
              </span>
            </button>
          </div>
          <Link to="/">
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#134E47]">
              Great Pharma
            </h1>
          </Link>
          <div className="d-flex py-3 px-6 sm:py-4 sm:px-10 md:py-4 md:px-4">
            <button className="text-[#134E47] font-semibold">
              <span className="bg-[#134E47] p-1 rounded-full text-center ">
                <FiShoppingBag
                  onClick={() => {
                    if (cart.length > 0) {
                      setIsOpen(true);
                    }
                  }}
                  className="text-white inline-block m-1"
                />
              </span>
            </button>
          </div>
        </div>
        <div className="flex">
          <div className="border-r-2  d-flex py-3 px-2 sm:py-3 sm:px-4 md:py-5 md:px-4">
            <label className="text-[#134E47]">Delivering To: </label>
            <select className="focus:outline-none focus:border-0 text-[#134E47] font-semibold">
              <option className=" text-[red]">3 Dhakeshwari Rd Dhaka</option>
            </select>
          </div>
          <div className="  d-flex py-3 px-6 sm:py-4 sm:px-10 md:py-5 md:px-4">
            <label className="text-[#134E47]">When: </label>
            <select className="focus:outline-none focus:border-0 text-[#134E47] font-semibold">
              <option className=" text-[red]">ASAP</option>
            </select>
          </div>
        </div>
      </div>
      <Login />
    </div>
  );
};

export default Navbar;
